var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1351_4655",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 4,
    width: 23,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.37305,
    y: 4.82495,
    width: 22.5882,
    height: 22.5882,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1351_4655)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.4204 16.1118L12.3308 9.02212C12.1438 8.83514 12.0526 8.61499 12.0573 8.36165C12.0622 8.10816 12.1581 7.88793 12.3451 7.70095C12.5322 7.51397 12.7525 7.42048 13.0058 7.42048C13.2591 7.42048 13.4794 7.51397 13.6665 7.70095L20.8863 14.9064C21.0565 15.0766 21.1826 15.2672 21.2646 15.4784C21.3467 15.6895 21.3877 15.9006 21.3877 16.1118C21.3877 16.3229 21.3467 16.534 21.2646 16.7452C21.1826 16.9563 21.0565 17.147 20.8863 17.3172L13.6665 24.5372C13.4794 24.7242 13.2567 24.8152 12.9985 24.8104C12.7403 24.8055 12.5177 24.7096 12.3308 24.5226C12.1438 24.3356 12.0503 24.1154 12.0503 23.8619C12.0503 23.6086 12.1438 23.3884 12.3308 23.2014L19.4204 16.1118Z",
    fill: "#3F3273"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightIcon);
export default __webpack_public_path__ + "static/media/arrow-right-icon.723fe590beb1ccfd94bdf3bb72a8d4a3.svg";
export { ForwardRef as ReactComponent };